// removed by extract-text-webpack-plugin
module.exports = {"container":"style__container___2vlIc"};


//////////////////
// WEBPACK FOOTER
// ./src/components/user-billing-payment/style.css
// module id = 1040
// module chunks = 0